import type { AlertProps } from 'apps/shared/ui/alert/alert';
import Alert from 'apps/shared/ui/alert/alert';
import ButtonRounded from 'apps/shared/ui/button-rounded/button-rounded';
import {
  StyledModalContentContainer,
  StyledModalFooterContainer,
  StyledModalHeaderContainer,
  StyledModalContainer,
  StyledModalWrapper,
} from 'apps/shared/ui/styleds/modal';
import type { ReactElement } from 'react';
import { Icon } from 'semantic-ui-react';

type ActionButtonProps = {
  label: string;
  onClick: () => unknown;
};

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: AlertProps['type'];
  title: string;
  message: string;
  confirm?: ActionButtonProps;
  cancel?: ActionButtonProps;
  renderActions?: () => ReactElement;
}

const Modal = (props: ModalProps) => {
  const { isOpen, type, message, title } = props;
  const { onClose, confirm, cancel, renderActions } = props;

  return (
    <StyledModalWrapper $isOpen={isOpen}>
      <StyledModalContainer>
        <StyledModalHeaderContainer>
          <p>{title}</p>
          <Icon name="x" onClick={onClose} />
        </StyledModalHeaderContainer>
        <StyledModalContentContainer>
          <Alert type={type} message={message} />
        </StyledModalContentContainer>
        <StyledModalFooterContainer>
          {cancel && (
            <ButtonRounded
              text={cancel.label}
              onClick={cancel.onClick}
              isOutlined
              spacingSizeHorizontal="medium"
            />
          )}
          {confirm && (
            <ButtonRounded text={confirm.label} onClick={confirm.onClick} spacingSizeHorizontal="medium" />
          )}
          {renderActions?.()}
        </StyledModalFooterContainer>
      </StyledModalContainer>
    </StyledModalWrapper>
  );
};

export default Modal;
